module.exports = __webpack_public_path__ + "media/images/promo/championship/icon_3-3ecacaf102b8fdbdb13f429912bc4356.png";